import stimulus from '../stimulus';
import PaymentElementController from './payment_element_controller';
import PaymentFormController from './payment_form_controller';

stimulus.register('checkout--payment-element', PaymentElementController);
stimulus.register('checkout--payment-form', PaymentFormController);
